exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pt0[data-v-a2b39eb0]{padding-top:0px !important}.divBox[data-v-a2b39eb0]{margin-left:-145px}\n", ""]);

// exports
